export default "__VITE_ASSET__DV4xOErf__"